import { List } from '@mui/material';
import * as Immutable from 'immutable';
import * as React from 'react';
import ListLayerContainer from '../../Layer/_containers/ListLayerContainer';
import LayerStore from '../../Layer/_stores/LayerStore';
import { Trans } from 'react-i18next';
import { Layers, AddCircleOutline } from '@mui/icons-material'

const T = ({children, ...otherProps}:any) => <Trans ns="create" {...otherProps}>{children}</Trans>

export type Props = {
	layersOrder?: Immutable.OrderedSet<string>
	selectedLayerId?: string
	addLayer?: Function
	opened?: boolean
}

export default class LayerList extends React.Component<Props> {
	private draggedLayer:Immutable.OrderedMap<string, LayerStore>;
	private layerListRef:React.RefObject<HTMLDivElement>;

	constructor(props:Props){
		super(props);
		this.layerListRef = React.createRef();
	}

	private onLayerAdd = () => this.props.addLayer();

	render() {
		let containerOffset = 0;

		if(this.layerListRef.current) {
			//let listElem = this.layerListRef.current.listElement.current;
			//containerOffset = listElem.offsetTop - parseFloat(getComputedStyle(listElem).getPropertyValue('padding-top'));
		}

		return this.props.opened && <>
				<div className="layer-list">
					<div className="layer-list-header">
						<h4><Layers /> <T>Layers</T></h4>
						<AddCircleOutline onClick={this.onLayerAdd} />
					</div>
					<div ref={this.layerListRef} className="layer-list-content">
						{this.props.layersOrder.valueSeq().reverse().map((id, index) => {
							return <ListLayerContainer key={id} id={id} layerIndex={this.props.layersOrder.count() - 1 - index} layerCount={this.props.layersOrder.count()} containerOffset={containerOffset}/>
						})}
					</div>
				</div>
			</>
	}
}